import classes from './NotFound.module.css'
import React from "react";

import notfound from"../../assets/SVG/404.svg";
import { Link } from 'react-router-dom';
export const NotFound: React.FC = () => {

    return(<>
        <div className={classes.NotFound}>
            <img src={notfound} alt="" />
            <Link to={'/'} style={{marginTop: 20, color: 'lightgreen'}}>الرئيسية</Link>
        </div>
    </>);
}